module.exports = __webpack_public_path__ + "img/mysql.2ebbdbb4.svg";